import { cn } from "@/helpers/className";

export type Icons =
  | "angle-down"
  | "angle-left"
  | "angle-right"
  | "arrow-right"
  | "arrow-right-light"
  | "article"
  | "bell"
  | "briefcase"
  | "calendar"
  | "chat"
  | "check"
  | "clock"
  | "close"
  | "coffee"
  | "coin"
  | "confetti"
  | "contract"
  | "contact"
  | "couch"
  | "delete"
  | "download"
  | "dot"
  | "eye"
  | "faq"
  | "facebook"
  | "fingerprint"
  | "fire"
  | "flag"
  | "gear"
  | "hammer"
  | "handshake"
  | "hashtag"
  | "heart"
  | "history"
  | "info"
  | "instagram"
  | "lifebuoy"
  | "list"
  | "linkedin"
  | "loader"
  | "location"
  | "love"
  | "love-fill"
  | "magnify"
  | "mail"
  | "map"
  | "map-pin"
  | "paperplane"
  | "pause"
  | "phone"
  | "play"
  | "play-circle"
  | "play-fill"
  | "plus"
  | "profile"
  | "question"
  | "search"
  | "share"
  | "sign-out"
  | "sliders"
  | "tag"
  | "tiktok"
  | "users"
  | "vacation"
  | "warning"
  | "wave"
  | "workid";

interface IconProps {
  className?: string;
  name: Icons;
}

const Icon = ({ name, className = "" }: IconProps) => {
  const classNames = cn("fill-current", className);
  // Note: When you change the icons, make sure to update the `v` query parameter in the href attribute to prevent caching issues.
  return (
    <svg className={classNames} aria-hidden="true">
      <use href={`/img/icons.svg?v=8fbc9c4fda843654b49ee37fd25e2141#${name}`} />
    </svg>
  );
};

export default Icon;
